import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Message } from '@mui/icons-material';

export interface ISnackbarAlert {
    id: string;
    message: string;
    type: 'error' | 'info' | 'success' | 'warning';
}

interface ISnackbarAlertProps {
    snackBarAlert: ISnackbarAlert | undefined;
    setIsOpen: (value: boolean) => void;
    isOpen: boolean | true;
    variant?: 'standard' | 'filled' | 'outlined' | undefined;
}
export const SnackbarAlert: React.FC<ISnackbarAlertProps> = ({ snackBarAlert, setIsOpen, isOpen, variant }) => {
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setIsOpen(!isOpen);
    };

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar
                id={snackBarAlert?.id}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={isOpen}
                autoHideDuration={3000}
                onClose={handleClose}
            >
                <Alert variant={variant ? variant : 'outlined'} onClose={handleClose} severity={snackBarAlert?.type} sx={{ width: '100%' }}>
                    {snackBarAlert?.message}
                </Alert>
            </Snackbar>
        </Stack>
    );
};
